// libs
import { styled } from '@nykaa/ui-components';

// mixin
import { resetButton, BaseButton } from 'shared/styles/mixin';

// components
import BaseSearchInput from 'shared/components/SearchInput';
import RippleEffect from 'shared/components/RippleIt';

// styles
import { BASE_GUTTER_SPACE, BG_GREY, COLORS, TEXT_PRIMARY } from 'shared/styles/base';
import { convertHexToRGBA } from 'shared/styles/mixin/core';

export const SearchWidgetContainer = styled.div`
  display: flex;
  align-items: center;
  padding: ${BASE_GUTTER_SPACE}px;
  background-color: ${BG_GREY};
  border-radius: 2px;
  height: 40px;
  position: relative;

  border-bottom: 2px solid ${convertHexToRGBA('#001325', 16)};

  .icon-search {
    font-size: 16px;
    margin-right: 8px;
    color: rgba(0, 19, 37, 0.36);
  }

  &:focus-within {
    border-bottom: 2px solid ${COLORS.BRAND_PRIMARY_100};
  }
  transition: border-bottom 0.2s ease;
`;

export const SearchInput = styled(BaseSearchInput)`
  border: none;
  width: 100%;
  & > .input {
    background-color: ${BG_GREY};
    color: ${TEXT_PRIMARY};
    ${({ theme }) => theme.typography.subTitleLarge};
  }
`;

export const BackIcon = styled(RippleEffect)`
  ${resetButton}

  height: 24px;
  width: 24px;
  ${({ theme }) => theme.typography.bodyLarge};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: ${BASE_GUTTER_SPACE * 2}px;
`;

export const ClearButton = styled(BaseButton)`
  height: 24px;
  width: 24px;
  font-size: 24px;
  object-fit: contain;
  opacity: 0.64;
  position: absolute;
  right: ${BASE_GUTTER_SPACE}px;
  cursor: pointer;
`;
